export const BID_FOLLOW_UP_FETCH_REQUESTED = 'BID_FOLLOW_UP_FETCH_REQUESTED'
export const BID_FOLLOW_UP_FETCH_SUCCESS = 'BID_FOLLOW_UP_FETCH_SUCCESS'
